ready(function () {
	const mapRoots = document.querySelectorAll('[data-interactive-map-root]');

	if (!mapRoots.length) {
		return;
	}

	mapRoots.forEach((root) => {
		initInteractiveMap(root);
	});

	if (typeof reinitCursor === 'function') {
		reinitCursor();
	}
});

function initInteractiveMap(root) {
	const stage = root.querySelector('[data-interactive-map-stage]');
	const svg = root.querySelector('[data-interactive-map-svg]');
	const popup = root.querySelector('[data-interactive-map-popup]');
	const popupScroll = root.querySelector('[data-interactive-map-scroll]');
	const popupTitle = root.querySelector('[data-interactive-map-title]');
	const popupBody = root.querySelector('[data-interactive-map-body]');
	const popupImageWrap = root.querySelector('[data-interactive-map-image-wrap]');
	const popupImage = root.querySelector('[data-interactive-map-image]');
	const popupDirections = root.querySelector('[data-interactive-map-directions]');
	const popupLink = popupDirections ? popupDirections.querySelector('a') : null;
	const closeButton = root.querySelector('[data-interactive-map-close]');
	const dataNode = root.querySelector('[data-interactive-map-data]');
	const popupId = popup.id;

	if (!stage || !svg || !popup || !dataNode) {
		return;
	}

	const hoverItems = parseInteractiveMapData(dataNode.textContent);

	if (!hoverItems.length) {
		return;
	}

	const itemsById = new Map();
	let activeTarget = null;
	let isOpen = false;
	let closeTimer = null;

	if (popup.parentNode !== document.body) {
		document.body.appendChild(popup);
	}

	hoverItems.forEach((item) => {
		const normalizedId = normalizeItemId(item.id);
		const target = findTargetByItemId(svg, normalizedId);

		if (!normalizedId || !target) {
			return;
		}

		itemsById.set(normalizedId, item);
		target.dataset.interactiveMapId = normalizedId;
		target.classList.add('cursor-pointer');
		ensureHitArea(target);
		target.setAttribute('role', 'button');
		target.setAttribute('tabindex', '0');
		target.setAttribute('aria-haspopup', 'dialog');
		target.setAttribute('aria-expanded', 'false');
		target.setAttribute('aria-controls', popupId);

		target.addEventListener('pointerdown', () => {
			target.dataset.interactiveMapPointerFocus = 'true';
		});

		target.addEventListener('click', () => {
			togglePopup(normalizedId, target);

			if (target.dataset.interactiveMapPointerFocus === 'true') {
				window.setTimeout(() => {
					target.blur();
				}, 0);
			}

			delete target.dataset.interactiveMapPointerFocus;
		});

		target.addEventListener('keydown', (event) => {
			if (event.key !== 'Enter' && event.key !== ' ') {
				return;
			}

			event.preventDefault();
			togglePopup(normalizedId, target);
		});

		target.addEventListener('blur', () => {
			delete target.dataset.interactiveMapPointerFocus;
		});
	});

	if (!itemsById.size) {
		return;
	}

	closeButton.addEventListener('click', closePopup);
	popupImage.addEventListener('load', () => {
		if (!isOpen || !activeTarget) {
			return;
		}

		positionPopup(popup, activeTarget);
	});

	document.addEventListener('click', (event) => {
		if (!isOpen) {
			return;
		}

		const clickedTarget = event.target.closest('[data-interactive-map-id]');

		if (popup.contains(event.target) || clickedTarget) {
			return;
		}

		if (!root.contains(event.target)) {
			closePopup();
			return;
		}

		closePopup();
	});

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape') {
			closePopup();
		}
	});

	window.addEventListener('resize', () => {
		if (!isOpen || !activeTarget) {
			return;
		}

		positionPopup(popup, activeTarget);
	});

	function togglePopup(itemId, target) {
		if (activeTarget === target && isOpen) {
			closePopup();
			return;
		}

		const item = itemsById.get(itemId);

		if (!item) {
			return;
		}

		openPopup(item, target);
	}

	function openPopup(item, target) {
		clearTimeout(closeTimer);
		resetActiveTarget();
		activeTarget = target;
		activeTarget.setAttribute('aria-expanded', 'true');

		popupTitle.textContent = item.heading || '';
		popupBody.innerHTML = item.body || '';
		resetPopupScroll(popupScroll);

		if (item.image && item.image.url) {
			popupImage.src = item.image.url;
			popupImage.alt = item.image.alt || '';
			popupImageWrap.classList.remove('hidden');
		} else {
			popupImage.removeAttribute('src');
			popupImage.alt = '';
			popupImageWrap.classList.add('hidden');
		}

		if (item.lat && item.lng && popupDirections && popupLink) {
			popupLink.href = buildGoogleMapsUrl(item.lat, item.lng);
			popupDirections.classList.remove('hidden');
		} else {
			if (popupLink) {
				popupLink.href = 'https://www.google.com/maps';
			}

			if (popupDirections) {
				popupDirections.classList.add('hidden');
			}
		}

		popup.classList.remove('hidden');
		popup.setAttribute('aria-hidden', 'false');
		positionPopup(popup, target);

		requestAnimationFrame(() => {
			popup.classList.remove('translate-y-2', 'opacity-0');
		});

		isOpen = true;
	}

	function closePopup() {
		if (!isOpen && popup.classList.contains('hidden')) {
			return;
		}

		resetActiveTarget();
		isOpen = false;
		popup.setAttribute('aria-hidden', 'true');
		popup.classList.add('translate-y-2', 'opacity-0');

		closeTimer = window.setTimeout(() => {
			popup.classList.add('hidden');
			popup.style.width = '';
			popup.style.left = '';
			popup.style.right = '';
			popup.style.top = '';
			popup.style.bottom = '';
		}, 200);
	}

	function resetActiveTarget() {
		if (!activeTarget) {
			return;
		}

		activeTarget.setAttribute('aria-expanded', 'false');
		activeTarget = null;
	}
}

function resetPopupScroll(popupScroll) {
	if (!popupScroll) {
		return;
	}

	popupScroll.scrollTop = 0;
}

function parseInteractiveMapData(data) {
	try {
		const parsed = JSON.parse(data || '[]');

		return Array.isArray(parsed) ? parsed : [];
	} catch (error) {
		return [];
	}
}

function findTargetByItemId(svg, normalizedId) {
	if (!normalizedId) {
		return null;
	}

	if (normalizedId === 'U2') {
		return svg.querySelector('g#U-2');
	}

	return svg.querySelector('g#' + CSS.escape(normalizedId));
}

function normalizeItemId(id) {
	return (id || '').trim().toUpperCase();
}

function buildGoogleMapsUrl(lat, lng) {
	return 'https://www.google.com/maps?q=' + encodeURIComponent(lat + ',' + lng);
}

function ensureHitArea(target) {
	if (!target || target.querySelector('[data-interactive-map-hitarea]')) {
		return;
	}

	const svgNamespace = 'http://www.w3.org/2000/svg';
	const bbox = target.getBBox();
	const paddingX = 10;
	const paddingY = 8;

	if (!bbox.width || !bbox.height) {
		return;
	}

	const hitArea = document.createElementNS(svgNamespace, 'rect');
	hitArea.setAttribute('data-interactive-map-hitarea', 'true');
	hitArea.setAttribute('x', bbox.x - paddingX);
	hitArea.setAttribute('y', bbox.y - paddingY);
	hitArea.setAttribute('width', bbox.width + (paddingX * 2));
	hitArea.setAttribute('height', bbox.height + (paddingY * 2));
	hitArea.setAttribute('fill', 'transparent');
	hitArea.style.pointerEvents = 'all';

	target.insertBefore(hitArea, target.firstChild);
}

function positionPopup(popup, target) {
	if (window.innerWidth < 768) {
		const mobileWidth = Math.min(window.innerWidth - 32, 420);

		popup.style.width = mobileWidth + 'px';
		popup.style.left = ((window.innerWidth - mobileWidth) / 2) + 'px';
		popup.style.right = 'auto';
		popup.style.top = '';
		popup.style.bottom = '1rem';
		return;
	}

	const margin = 16;
	const targetRect = target.getBoundingClientRect();
	const viewportWidth = window.innerWidth;
	const viewportHeight = window.innerHeight;
	const desktopWidth = Math.min(720, viewportWidth - 64);

	popup.style.width = desktopWidth + 'px';

	const popupRect = popup.getBoundingClientRect();

	let left = targetRect.right + margin;

	if (left + popupRect.width > viewportWidth - margin) {
		left = targetRect.left - popupRect.width - margin;
	}

	left = clamp(left, margin, Math.max(margin, viewportWidth - popupRect.width - margin));

	let top = targetRect.top + (targetRect.height / 2) - (popupRect.height / 2);
	top = clamp(top, margin, Math.max(margin, viewportHeight - popupRect.height - margin));

	popup.style.left = left + 'px';
	popup.style.right = 'auto';
	popup.style.top = top + 'px';
	popup.style.bottom = 'auto';
}

function clamp(value, min, max) {
	return Math.min(Math.max(value, min), max);
}
